export default __webpack_public_path__ + "static/media/507.38577bc8.png";